exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.headline_box .weui-dialog {\n  width: 85%;\n  max-width: 95%;\n  border-radius: 0.24rem;\n  /* 18/75 */\n}\n", ""]);

// exports
